<template>
  <div class="delete-modal">
    <modal
      :show.sync="localDisplay"
      modal-classes="modal-dialog-centered modal-xl"
    >
      <template slot="header">
        <h4 class="modal-title" id="exampleModalLabel">
          {{ $t('mayday-web.notification-dropdown.notification-history') }}
        </h4>
      </template>
      <div class="container full-notification-feed-container">
        <div class="row justify-content-end">
          <div class="col-xl-4 col-md-6 col-sm-12 mb-2">
            <el-input
              class
              placeholder="Rechercher une notification"
              prefix-icon="el-icon-search"
              v-model="modalSearch"
            ></el-input>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <el-collapse
              class="notification-center-collapse"
              v-model="openedRows"
            >
              <el-collapse-item
                v-for="notification in filteredNotifications"
                :key="notification.id"
                :name="notification.id"
                class="collapse-item"
              >
                <template slot="title" class="row justify-content-between">
                  <div class="col title-col">
                    <strong class="pr-2">{{ notification.title }}</strong>
                    <span v-if="notification.urgent">
                      <font-awesome-icon
                        class="urgent-icon"
                        color="red"
                        :icon="['fa', 'exclamation-circle']"
                      ></font-awesome-icon>
                    </span>
                  </div>
                  <div
                    class="col-2 info-col text-right collapse-title-text d-none d-lg-block"
                  >
                    <small>
                      <font-awesome-icon
                        :icon="['fa', 'calendar-day']"
                        class="mr-1"
                      ></font-awesome-icon>
                      {{ dateParser(notification.createdAt) }}
                    </small>
                  </div>
                </template>

                <div class="mb-2">
                  <div class="ml-3 mb-2 d-lg-none">
                    <small>
                      <font-awesome-icon
                        :icon="['fa', 'calendar-day']"
                        class="mr-1"
                      ></font-awesome-icon>
                      {{ dateParser(notification.createdAt) }}
                    </small>
                  </div>
                  <div class="col-12">
                    <MaydayNotificationEditor
                      class="notification__viewer"
                      :message="notification.message"
                      :editable="false"
                    />
                  </div>
                  <p
                    v-if="notification.attachedObjectId"
                    class="col-12 mt-2 content-link"
                    @click="goToContent(notification.attachedObjectId)"
                  >
                    {{
                      $t('mayday-web.notification-dropdown.attached-content')
                    }}
                  </p>
                  <div class="col-12 my-2" v-if="!notification.wasUrgent">
                    <MaydayWebNotificationModalItemCheckbox
                      :notification="notification"
                    />
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button type="primary" outline size="sm" @click="$emit('close')"
          >fermer</base-button
        >
      </template>
    </modal>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import MaydayNotificationEditor from '@/components/Editors/MaydayNotificationEditor';
import MaydayWebNotificationModalItemCheckbox from './MaydayWebNotificationModalItemCheckbox.vue';

export default {
  name: 'mayday-web-notification-modal',
  components: {
    MaydayNotificationEditor,
    MaydayWebNotificationModalItemCheckbox,
  },
  props: {
    display: Boolean,
    focusedNotifications: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    filteredNotifications() {
      let notifications = [...this.notifications];
      if (this.urgentNotification) {
        notifications = [this.urgentNotification].concat(notifications);
      }
      if (this.modalSearch !== '') {
        notifications = notifications.filter((n) =>
          n.title.toLowerCase().includes(this.modalSearch.toLowerCase()),
        );
      }
      return notifications;
    },
    ...mapState('webKnowledgeModule', ['notifications', 'urgentNotification']),
    ...mapGetters(['isParametric']),
  },
  data() {
    return {
      localDisplay: this.display,
      modalSearch: '',
      openedRows: [],
    };
  },
  mounted() {
    this.openedRows = this.focusedNotifications;
  },
  methods: {
    goToContent(contentId) {
      let path = this.isParametric
        ? `/web-parametric/content/${contentId}`
        : `/web/content/${contentId}`;
      this.$router.push({
        path: path,
      });
      this.localDisplay = !this.localDisplay;
    },
    userChoice(choice) {
      this.isLoading = true;
      this.$emit('choice', choice);
    },
    dateParser(date) {
      return new Date(Date.parse(date)).toLocaleString([], {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
    ...mapActions('webKnowledgeModule', ['readAgentNotification']),
  },
  watch: {
    localDisplay() {
      if (!this.localDisplay) this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
.title-col {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}

.full-notification-feed-container {
  max-height: 50vh;
  overflow: auto;
}

.content-link {
  font-size: 12px;
  color: $blue-mayday;
  cursor: pointer;
}

.notification__viewer {
  border-left: 4px solid $grey-4-mayday;
  background-color: $grey-1-mayday;
  border-radius: 2px;
}
</style>
